import { Modal,Form, Button } from "react-bootstrap";

export default function settings({
    show,
    onHide,
    id,
    onRole1Change,
    onRole2Change,
    onSave,
  }: {
    show: boolean;
    onHide: () => void;
    id: string;
    onRole1Change: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onRole2Change: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onSave: () => void;
  }) {
    return (
      <Modal show={show} onHide={onHide}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Settings for Server: {id}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>Accept Role</Form.Label>
              <Form.Control
                type="text"
                onChange={onRole1Change}
                placeholder="Enter accept role ID"
                required
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Kick Role</Form.Label>
              <Form.Control
                type="text"
                onChange={onRole2Change}
                placeholder="Enter kick role ID"
                required
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Close
          </Button>
          <Button variant="primary" onClick={onSave}>
            Save
          </Button>
          <Button variant="danger">Kick</Button>
        </Modal.Footer>
      </Modal>
    );
  }
  